import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 9,
	viewBox: "0 0 9 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.56625 2.49094L6.55594 3.25969H8.15063V7.49094C8.15063 8.01531 7.72406 8.44188 7.19969 8.44188H0.949687C0.425938 8.44188 0 8.01594 0 7.49219V3.25969H1.59469L1.58438 2.49469C1.58438 1.1175 2.70188 0 4.07531 0C5.44875 0 6.56625 1.1175 6.56625 2.49094ZM5.95937 2.48719C5.95937 1.45219 5.11438 0.606875 4.07531 0.606875V0.607188C3.03656 0.607188 2.19125 1.45219 2.19125 2.49125L2.20031 3.26031H5.95031L5.95937 2.48719ZM7.19969 7.79156C7.36531 7.79156 7.5 7.65688 7.5 7.49125V3.91063H0.650625V7.4925C0.650625 7.6575 0.784688 7.79156 0.949687 7.79156H7.19969ZM3.76285 6.55437V5.82468C3.58598 5.71812 3.46629 5.52593 3.46629 5.30437C3.46629 4.96781 3.73879 4.69531 4.07535 4.69531C4.41191 4.69531 4.68441 4.96812 4.68441 5.30437C4.68441 5.52593 4.56473 5.71812 4.38785 5.82468V6.55437C4.38785 6.72687 4.24785 6.86687 4.07535 6.86687C3.90285 6.86687 3.76285 6.72687 3.76285 6.55437Z",
		fill: "#37003C"
	})
});
export default SvgLocked;
